import { routing } from "@/i18n/routing";
import { getLink } from "@frend-digital/storyblok";

export const removeSegments = ["products", "pages", "categories", ...routing.languages];

export const sbLink = (link: Parameters<typeof getLink>[0] | string) => {
	return getLink(link as Parameters<typeof getLink>[0], removeSegments);
};
